<template>
  <div class="ibox">
    <div class="ibox-content">

      <form class="form-material">

        <h2>Default Notification Settings</h2>

        <div class="margin-20"></div>

        <div class="form-group m-b-lg">
          <div class="checkbox checkbox-primary">
            <input id="check-notify-email" class="styled" type="checkbox" v-model="notifyJobStatus">
            <label for="check-notify-email">
              Notify me of job status updates
            </label>
          </div>
          <div class="checkbox checkbox-primary">
            <input id="check-notify-email-delivery" class="styled" type="checkbox" v-model="notifyLoadDeliveries">
            <label for="check-notify-email-delivery">
              Notify me of load deliveries
            </label>
          </div>
          <div class="checkbox checkbox-primary">
            <input id="check-notify-job-completed" class="styled" type="checkbox" v-model="notifyJobCompleted">
            <label for="check-notify-job-completed">
              Notify me of invoices and payments
            </label>
          </div>
          <div class="checkbox checkbox-primary">
            <input id="check-notify-children" class="styled" type="checkbox" v-model="notifyChildren">
            <label for="check-notify-children">
              Apply notification settings to other users in our organisation (if I have any)
            </label>
          </div>
          <div class="checkbox checkbox-primary">
            <input id="notify-public-jobs" v-model="notifyPublicJobs" type="checkbox" class="styled"/>
            <label for="notify-public-jobs">
              Receive email about public jobs
            </label>
          </div>
        </div><!-- /.form-group -->

        <div class="text-right">
          <ladda-button type="success" :on-click="handleSaveChanges">Save All Changes</ladda-button>
        </div>

      </form><!-- /.form-material -->

    </div>
  </div><!-- /.ibox -->
</template>

<script>
  import { mapActions, mapMutations } from 'vuex'
  import { SET_AUTHORIZED, SET_USER_ATTRIBUTE } from 'vx/mutations'
  import { existingUser, stateMapper } from 'mixins/user'
  import { LaddaButton } from 'components/forms'
  import { pick } from 'lodash'
  import { notify } from 'utils'

  export default {
    mixins: [existingUser, stateMapper],

    data () {
      return {
        stateProperty: 'user',
        mutationProperty: SET_USER_ATTRIBUTE
      }
    },

    components: {
      LaddaButton
    },

    created () {
      // Admins do not have notifications for jobs and loads nor can they modify a users
      // so we'll kick them out if they try and hit this route.
      if (this.$user.isAdmin) {
        this.$router.push({ name: 'account.settings' })

        return
      }

      this.useAuthorizedUser()
    },

    methods: {
      ...mapActions('user', ['updateUser']),
      ...mapMutations('user', [SET_AUTHORIZED]),

      /**
       * Handle saving notification changes.
       *
       * @return void
       */
      handleSaveChanges () {
        const updateAuthorizedUserIfRequired = (response) => {
          if (this.user.id === this.$user.id) {
            this[SET_AUTHORIZED](response.data)
          }
        }

        const notifyUpdated = () => (notify.success('Notification settings have been saved.'))
        const notifyFailed = () => (notify.error('Unable to save notification settings.'))

        // Pick only the four required fields from the users profile to send as
        // the payload to the API.
        const payload = pick(this.user.profile, [
          'notify_job_status',
          'notify_load_deliveries',
          'notify_job_completed',
          'notify_children',
          'notify_public_jobs'
        ])

        return this.updateUser({ id: this.user.id, payload })
          .then(updateAuthorizedUserIfRequired)
          .then(notifyUpdated)
          .catch(notifyFailed)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Notifications.vue?2c55b921